import { render, staticRenderFns } from "./tax-code-tab.vue?vue&type=template&id=9626ad8c"
import script from "./tax-code-tab.vue?vue&type=script&lang=js"
export * from "./tax-code-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports